export default {
    getAllProjects: groupId => {
        return {
            url: '/groups/:groupId/projects?per_page=100',
            method: 'GET',
            route_params: {
                groupId
            }
        };
    },
    getProject: projectId => {
        return {
            url: '/projects/:projectId',
            method: 'GET',
            route_params: {
                projectId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Projects/api.js